"use client";

import { ImageShowcase } from "@/app/(marketing)/components/demo/showcases/ImageShowcase";
import { StarPoint } from "@/app/(marketing)/components/demo/showcases/StarPoint";
import { ButtonLink } from "@/components/buttons/ButtonLink";
import screenshot from "@/public/images/appScreenshots/isolate-vocals.png";

export function IsolateShowcase() {
  return (
    <ImageShowcase
      screenshot={screenshot}
      headingText="Isolate vocals"
      altText="Screenshot of isolate vocals page"
    >
      <ul className="flex flex-col gap-y-2">
        <StarPoint>
          Quickly extract dry vocals from any song using our state-of-the-art AI
          models
        </StarPoint>
        <StarPoint>Remove noise and effects from your samples</StarPoint>
      </ul>
      <ButtonLink external={false} href="/isolate" className="mt-6 block w-fit">
        Explore
      </ButtonLink>
    </ImageShowcase>
  );
}
